import { useEffect } from "react";
import CreateTemplate from "../../../../components/AssetManagement/Design/Templates/CreateNewTemplate/CreateTemplate";
import { useSelector } from "react-redux";
import { selectUserData } from "../../../../features/userSlice";
import store from "../../../../store";
import { setSiteOptions } from "../../../../features/templateSlice";

function CreateTemplateScreen() {
  const response = useSelector(selectUserData);

  useEffect(() => {
    if (response?.data?.website_permissions) {
      const siteOptions = response.data.website_permissions.map(
        (siteObj: any) => {
          const uid = Object.keys(siteObj)[0]; // UID of the site
          const siteName = siteObj[uid].ui_site_name; // Site name
          return { uid, siteName }; // Return as an object with uid and siteName
        }
      );

      store.dispatch(setSiteOptions(siteOptions)); // Dispatch the memoized options
    }
  }, [response]);

  return (
    <div>
      <CreateTemplate />
    </div>
  );
}

export default CreateTemplateScreen;
